import AODPrevDocSvg from "./AODPrevDocSvg";
import AODPrevDocHoverSvg from "./AODPrevDocHoverSvg";
import AODCommentDocSvg from "./AODCommentDocSvg";
import AODCommentDocHoverSvg from "./AODCommentDocHoverSvg";
import AODHasCommentDocSvg from "./AODHasCommentDocSvg";
import AODHasCommentDocHoverSvg from "./AODHasCommentDocHoverSvg";
import AODDownloadDocSvg from "./AODDownloadDocSvg";
import AODDownloadDocHoverSvg from "./AODDownloadDocHoverSvg";
import AODSendEmailSvg from "./AODSendEmailSvg";
import AODSendEmailHoverSvg from "./AODSendEmailHoverSvg";
import AODDeleteDocSvg from "./AODDeleteDocSvg";
import AODDeleteDocHoverSvg from "./AODDeleteDocHoverSvg";

export const AODSvgExport = {
  AODPrevDocSvg,
  AODPrevDocHoverSvg,
  AODCommentDocSvg,
  AODCommentDocHoverSvg,
  AODHasCommentDocSvg,
  AODHasCommentDocHoverSvg,
  AODDownloadDocSvg,
  AODDownloadDocHoverSvg,
  AODSendEmailSvg,
  AODSendEmailHoverSvg,
  AODDeleteDocSvg,
  AODDeleteDocHoverSvg,
};
